/**
 * Coach console: hide Firestore document IDs from the default UI; allow developers
 * to reveal them via URL, storage, or a hidden gesture (see hook + MainHeader).
 */

export const COACH_CONSOLE_DOC_IDS_STORAGE_KEY = "m45CoachConsoleShowDocIds";

export function readCoachConsoleDocumentIdsVisible() {
  if (typeof window === "undefined") return false;
  try {
    if (window.sessionStorage?.getItem(COACH_CONSOLE_DOC_IDS_STORAGE_KEY) === "1") {
      return true;
    }
    if (window.localStorage?.getItem(COACH_CONSOLE_DOC_IDS_STORAGE_KEY) === "1") {
      return true;
    }
    const params = new URLSearchParams(window.location.search);
    if (params.get("docIds") === "1" || params.get("debugIds") === "1") {
      return true;
    }
  } catch (_) {
    /* ignore */
  }
  return false;
}

/** Call once when the SPA loads (e.g. from App). Persists ?docIds=1 into sessionStorage. */
export function initCoachConsoleDocumentIdsFromUrl() {
  if (typeof window === "undefined") return;
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get("docIds") === "1" || params.get("debugIds") === "1") {
      window.sessionStorage.setItem(COACH_CONSOLE_DOC_IDS_STORAGE_KEY, "1");
    }
  } catch (_) {
    /* ignore */
  }
}

/** Toggle visibility; returns new state (true = IDs visible). */
export function toggleCoachConsoleDocumentIdsVisible() {
  if (typeof window === "undefined") return false;
  const next = !readCoachConsoleDocumentIdsVisible();
  try {
    if (next) {
      window.sessionStorage.setItem(COACH_CONSOLE_DOC_IDS_STORAGE_KEY, "1");
    } else {
      window.sessionStorage.removeItem(COACH_CONSOLE_DOC_IDS_STORAGE_KEY);
      window.localStorage.removeItem(COACH_CONSOLE_DOC_IDS_STORAGE_KEY);
    }
    window.dispatchEvent(new CustomEvent("m45-coach-console-doc-ids-visibility"));
  } catch (_) {
    /* ignore */
  }
  return next;
}
